import React from "react";
import { useBlockData } from "@yoopta/editor";
import Typography from "@mui/material/Typography";
import { useGameIdFromRoute } from "../../../../games/WithGameIdFromRoute.js";
import { useGame } from "@seabrookstudios/pitch2table";

const GameTitleRender = ({ extendRender, ...props }) => {
  const { blockId, children } = props;
  const blockData = useBlockData(blockId);

  // Get the current game ID from the route
  const gameId = useGameIdFromRoute();
  const { data: game, isLoading } = useGame(gameId);

  // Get the current alignment from block metadata
  const currentAlign = blockData?.meta?.align || "left";
  const alignClass = `yoopta-align-${currentAlign}`;

  // Show loading state while fetching game data
  if (isLoading) {
    return (
      <div
        contentEditable={false}
        draggable={false}
        className={`yoo-image-mt-4 yoo-image-relative yoo-image-flex ${alignClass} yoopta-game-title`}
        style={{ maxWidth: "100%", overflow: "hidden" }}
      >
        <Typography variant="h2" style={{ fontSize: 24, fontWeight: "bold" }}>
          Loading...
        </Typography>
        {children}
      </div>
    );
  }

  // Show game title or fallback
  const gameTitle = game?.name || "Game Title Not Available";

  return (
    <div
      contentEditable={false}
      draggable={false}
      className={`yoo-image-mt-4 yoo-image-relative yoo-image-flex ${alignClass} yoopta-game-title`}
      style={{ maxWidth: "100%", overflow: "hidden" }}
    >
      {extendRender ? (
        extendRender(props)
      ) : (
        <Typography
          variant="h2"
          style={{
            fontSize: 24,
            fontWeight: "bold",
            fontFamily: "'aktiv-grotesk', sans-serif",
            margin: 0,
            padding: "8px 0",
          }}
        >
          {gameTitle}
        </Typography>
      )}
      {children}
    </div>
  );
};

export { GameTitleRender };
